var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"opacity-7 mb-0"},[_vm._t("default"),(_vm.text.length)?_c('ExpandableText',{attrs:{"icon":"mdi-comment-text-outline","text":_vm.text}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }